<template>
  <div class="valvulas">
    <div class="navbar-content">
      <Navbar />
    </div>
    <main class="all">
      <section class="card">
        <img src="../assets/valvulas/1valvulas.jpg" alt="Válvula Modelo Borboleta" class="icon" />
        <h3>Válvula Modelo Borboleta</h3>
        <a :href="valvulaBorboletaPDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/2valvulas.jpg" alt="Válvula Modelo API-609" class="icon" />
        <h3>Válvula Modelo API-609</h3>
        <a :href="valvulaAPIPDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/3valvulas.jpg" alt="Válvula Modelo Comporta" class="icon" />
        <h3>Válvula Modelo Comporta</h3>
        <a :href="valvulaComportaPDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/4valvulas.jpg" alt="Válvula Modelo VC38" class="icon" />
        <h3>Válvula Modelo VC38</h3>
        <a :href="valvulaVC38PDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/5valvulas.jpg" alt="BVálvula Modelo VG37" class="icon" />
        <h3>Válvula Modelo VG37</h3>
        <a :href="valvulaVG37PDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/6valvulas.jpg" alt="Válvula Modelo VG38" class="icon" />
        <h3>Válvula Modelo VG38</h3>
        <a :href="valvulaVG38PDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/7valvulas.jpg" alt="Válvula Modelo VG39" class="icon" />
        <h3>Válvula Modelo VG39</h3>
        <a :href="valvulaVG39PDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/8valvulas.jpg" alt="Válvula Modelo VRSP" class="icon" />
        <h3>Válvula Modelo VRSP</h3>
        <a :href="valvulaVRSPPDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/valvulas/9valvulas.jpg" alt="Turbina Hidráulica" class="icon" />
        <h3>Turbina Hidráulica</h3>
        <a :href="valvulaTurbinaPDF" target="_blank">
          <button class="button">
            <img src="../assets/valvulas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
    </main>
    <Bottom />
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import Bottom from "./Bottom.vue";

import valvulaAPI from "../assets/valvulas/FT_API_609.pdf";
import valvulaComporta from "../assets/valvulas/FT_Comporta.pdf";
import valvulaTurbina from "../assets/valvulas/FT_Turbina.pdf";
import valvulaBorboleta from "../assets/valvulas/FT_Válvula Borboleta.pdf";
import valvulaVC38 from "../assets/valvulas/FT_VC38.pdf";
import valvulaVG37 from "../assets/valvulas/FT_VG37.pdf";
import valvulaVG38 from "../assets/valvulas/FT_VG38.pdf";
import valvulaVG39 from "../assets/valvulas/FT_VG39.pdf";
import valvulaVRSP from "../assets/valvulas/FT_VRSP.pdf";
export default {
  name: "Valvulas",
  components: {
    Navbar,
    Bottom,
  },
  data() {
    return {
      valvulaAPIPDF: valvulaAPI,
      valvulaComportaPDF: valvulaComporta,
      valvulaTurbinaPDF: valvulaTurbina,
      valvulaBorboletaPDF: valvulaBorboleta,
      valvulaVC38PDF: valvulaVC38,
      valvulaVG37PDF: valvulaVG37,
      valvulaVG38PDF: valvulaVG38,
      valvulaVG39PDF: valvulaVG39,
      valvulaVRSPPDF: valvulaVRSP,
    };
  },
};
</script>

<style scoped>
.valvulas {
  background-color: #f5f5f5;
  background-image: linear-gradient(to right,
      rgba(52, 51, 51, 0.1) 2px,
      transparent 1px),
    linear-gradient(to bottom, rgba(52, 51, 51, 0.1) 2px, transparent 1px);
  background-size: 3.4vw 3.4vw;
}

.navbar-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.all {
  display: flex;
  padding-top: 150px;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #fff;
  padding: 15px;
  border-radius: 5px;
  height: 351px;
  width: 350px;
  margin: 0 50px 70px 50px;
  box-shadow: 3px 3px 3px #00000080;
}

h3 {
  color: #000000;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 21px;
  margin: 10px 0;
  text-align: center;
}

.icon {
  width: 100%;
  max-width: 100%;
  height: auto;
  box-shadow: 0px 0px 2px #000000cc;
  border-radius: 5px;
}

.button {
  color: #16181a;
  background-color: #ffc737;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: 400;
  opacity: 0.85;
  text-align: center;
  border-radius: 4.5px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  width: 100%;
  height: 100%;
  box-shadow: 2.9px 2.9px 4.3px #00000080;
}

.icon-pdf {
  color: #38393b;
  width: 14%;
  height: auto;
  margin-left: 0.4em;
  order: 1;
}

@media only screen and (max-width: 600px) {
  .card {
    padding: 15px;
    height: 70%;
    width: 70%;
    margin: 0 5vw 8vw 5vw;
  }

  h3 {
    font-size: 2.7vw;
    margin: 1.5vw 0;
  }

  .button {
    font-size: 3vw;
    min-width: 25px;
  }
}
</style>